import Notifications, { notify } from 'notiwind'
import { i18n } from '@/plugins/i18n'

/**
 * size: "sm" | "md"
 * variant: "success" | "error" | "info"
 * text: i18n key OR plain text
 * group: NotificationGroup name
 */
function makePayload({
                         size = 'md',
                         variant = 'info',
                         text = '',
                         group = 'app'
                     }) {
    const isSm = size === 'sm'
    const base = isSm ? 'px-4 py-3 text-sm' : 'px-5 py-4 text-lg'

    const bg = {
        error: 'bg-toast-dark-error',
        success: 'bg-toast-dark-success',
        info: 'bg-toast-dark-info',
    }[variant] || 'bg-toast-dark-info'

    let message = i18n.global.t('error_unknown')
    if (i18n.global.te(text)) {
        message = i18n.global.t(text)
    } else if (i18n.global.te(`error_${text}`)) {
        message = i18n.global.t(`error_${text}`)
    } else if (text) {
        message = String(text)
    }

    return {
        group,
        title: '',
        text: message,
        type: variant,
        meta: { size, variant, classes: `${base} ${bg}` }
    }
}

// Built once at module load so it can be used outside components too
// (e.g. the router guard, which has no component instance to `inject` from).
export const toast = {
    success(text, { size = 'md', timeout = 3000, group = 'app' } = {}) {
        notify(makePayload({ size, variant: 'success', text, group }), timeout)
    },

    error(text, { size = 'md', timeout = 3000, group = 'app' } = {}) {
        notify(makePayload({ size, variant: 'error', text, group }), timeout)
    },

    info(text, { size = 'md', timeout = 3000, group = 'app' } = {}) {
        notify(makePayload({ size, variant: 'info', text, group }), timeout)
    },

    show(text, { variant = 'info', size = 'md', timeout = 3000, group = 'app' } = {}) {
        notify(makePayload({ size, variant, text, group }), timeout)
    }
}

export default {
    install(app, options = {}) {
        app.use(Notifications, options.notiwind || {})

        const api = toast

        app.config.globalProperties.$toast = api
        app.provide('toast', api)
    }
}
